module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/babel-runtime/core-js/object/assign.js
 ** module id = 1496
 ** module chunks = 0
 **/